import { NonIndexRouteObject } from 'react-router';

import { HomeRoutes } from '../../../../../RouteConstants';
import { DBLoginPublicRoutes } from './dbLogin.routes';
import { OAuthLoginPublicRoutes } from './oAuth.routes';
import { SuperAdminLoginPublicRoutes } from './adminLogin.routes';
import { LoadingIndicator } from '@components/LoadingIndicatorMaterial';
import { RouteErrorPage } from '@components/ErrorBoundary';

/**
 * These are all of the public routes.
 * It mostly consists of login routes for the various auth types
 */
export const PublicRoutes: NonIndexRouteObject[] = [
  // DB Login routes
  ...DBLoginPublicRoutes,

  // external oAuth (SSO) routes
  ...OAuthLoginPublicRoutes,

  // super admin (pod manager login)
  ...SuperAdminLoginPublicRoutes,

  // other public routes
  {
    path: `/${HomeRoutes.terms}`,
    hydrateFallbackElement: <LoadingIndicator isLoading />,
    errorElement: <RouteErrorPage />,
    async lazy() {
      const HomeLayoutLoginRoutes = (
        await import('../../../../../../Modules/Home/HomeLayouts/HomeLayoutLoginRoutes')
      ).default;
      const TermsAndConditions = (
        await import('../../../../../../Modules/Home/TermsAndConditions/TermsAndConditions')
      ).default;

      return {
        element: <HomeLayoutLoginRoutes content={<TermsAndConditions />} />,
        errorElement: <RouteErrorPage />,
      };
    },
  },
  {
    path: `${HomeRoutes.notAuthorized}`,
    hydrateFallbackElement: <LoadingIndicator isLoading />,
    errorElement: <RouteErrorPage />,
    async lazy() {
      const NotAuthorized = (await import('../../../../../../Modules/NotAuthorized/NotAuthorized'))
        .default;

      return {
        element: <NotAuthorized />,
        errorElement: <RouteErrorPage />,
      };
    },
  },
  {
    path: `${HomeRoutes.notSetup}`,
    hydrateFallbackElement: <LoadingIndicator isLoading />,
    errorElement: <RouteErrorPage />,
    async lazy() {
      const NotSetup = (await import('../../../../../../Modules/NotSetup/NotSetup')).default;

      return {
        element: <NotSetup />,
        errorElement: <RouteErrorPage />,
      };
    },
  },
];
